import angular from 'angular';
import maintenaceAdminListComponent from './maintenance-admin-list.component';

export default angular.module('components.app.product.maintenanceAdminList', [])
  .component('maintenanceAdminList', maintenaceAdminListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/maintenance-admin-list/maintenance-admin-list.module.js